module.exports = __webpack_public_path__ + "img/apk_store.04fdf6f.png";